module.exports = __webpack_public_path__ + "static/media/pexels-photo-341523.62480a9f.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/components/common/app2soft/images/005_mo/pexels-photo-341523.jpeg
// module id = 774
// module chunks = 0